import { type FC } from 'react';

import type {
  DashboardWidgetProps,
  WidgetChartConfigCamelizedDefault,
} from 'src/types/dashboard';
import { apiPaths } from 'src/services/api/apiPaths';
import BaseTrendAnalysisWidget from 'src/components/dashboard/DashboardPage/components/BaseWidget/TrendAnalysisWidget';

const NpsTrendAnalysisWidget: FC<DashboardWidgetProps> = ({ config }) => {
  const chartConfigDefault: WidgetChartConfigCamelizedDefault = {
    yAxisMax: 100,
    yAxisMin: -100,
    yAxisStepSize: 25,
  };

  return (
    <BaseTrendAnalysisWidget
      config={config}
      endpointPath={apiPaths.WIDGET_DATA.NPS_TREND_ANALYSIS}
      chartConfigDefault={chartConfigDefault}
    />
  );
};
export default NpsTrendAnalysisWidget;
